import React, { useState } from 'react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardSidebar } from '../components/dashboard/DashboardSidebar';
import { SettingsIcon, GlobeIcon, BellIcon, ShieldIcon, KeyIcon, DatabaseIcon, SaveIcon, CheckIcon, XIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function SettingsDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const [successMessage, setSuccessMessage] = useState('');
  // Mock user data
  const [userData] = useState({
    name: 'FATHALLAH Mehdi',
    company: 'Tunipages',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    email: 'mehdi.fathallah@tunipages.com'
  });
  // Mock settings
  const [settings, setSettings] = useState({
    language: 'Français',
    timeZone: 'Europe/Paris',
    dateFormat: 'DD/MM/YYYY',
    currency: 'EUR',
    emailNotifications: {
      newTenders: true,
      tenderUpdates: true,
      weeklyDigest: true,
      marketingEmails: false
    },
    appNotifications: {
      newTenders: true,
      tenderUpdates: true,
      systemAlerts: true
    },
    dataRetention: {
      searchHistory: 30,
      downloadedDocuments: 90
    },
    exportFormat: 'PDF'
  });
  const handleSettingChange = (section: string, setting: string, value: any) => {
    setSettings({
      ...settings,
      [section]: {
        ...settings[section as keyof typeof settings],
        [setting]: value
      }
    });
  };
  const handleSimpleSettingChange = (setting: string, value: any) => {
    setSettings({
      ...settings,
      [setting]: value
    });
  };
  const handleSave = () => {
    // Here you would typically send the updated settings to your backend
    console.log('Saving settings:', settings);
    setSuccessMessage('Vos paramètres ont été mis à jour avec succès!');
    // Clear success message after a delay
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-3531">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && <div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarOpen(false)} data-id="element-3532" />}
      {/* Sidebar */}
      <DashboardSidebar open={sidebarOpen} setOpen={setSidebarOpen} data-id="element-3533" />
      {/* Main content */}
      <div className="md:pl-64" data-id="element-3534">
        {/* Header */}
        <DashboardHeader user={userData} onMenuClick={() => setSidebarOpen(true)} data-id="element-3535" />
        {/* Main content */}
        <main className="py-6 px-4 sm:px-6 lg:px-8" data-id="element-3536">
          {/* Page header */}
          <div className="mb-6" data-id="element-3537">
            <div className="flex items-center mb-4" data-id="element-3538">
              <SettingsIcon size={24} className="text-blue-600 mr-3" data-id="element-3539" />
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-3540">Paramètres</h1>
            </div>
            <p className="text-gray-600" data-id="element-3541">
              Configurez vos préférences pour personnaliser votre expérience
            </p>
          </div>
          {/* Success message */}
          {successMessage && <div className="mb-6 bg-green-100 border border-green-200 text-green-800 rounded-lg p-4 flex items-start" data-id="element-3542">
              <CheckIcon size={20} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-3543" />
              <div data-id="element-3544">
                <p className="font-medium" data-id="element-3545">{successMessage}</p>
              </div>
              <button onClick={() => setSuccessMessage('')} className="ml-auto text-green-500 hover:text-green-700" data-id="element-3546">
                <XIcon size={16} data-id="element-3547" />
              </button>
            </div>}
          <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100" data-id="element-3548">
            {/* Tabs navigation */}
            <div className="border-b border-gray-200" data-id="element-3549">
              <nav className="flex overflow-x-auto" data-id="element-3550">
                <button onClick={() => setActiveTab('general')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'general' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3551">
                  <GlobeIcon size={16} className="inline-block mr-2" data-id="element-3552" />
                  Général
                </button>
                <button onClick={() => setActiveTab('notifications')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'notifications' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3553">
                  <BellIcon size={16} className="inline-block mr-2" data-id="element-3554" />
                  Notifications
                </button>
                <button onClick={() => setActiveTab('security')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'security' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3555">
                  <ShieldIcon size={16} className="inline-block mr-2" data-id="element-3556" />
                  Sécurité
                </button>
                <button onClick={() => setActiveTab('data')} className={`py-4 px-6 font-medium text-sm border-b-2 whitespace-nowrap ${activeTab === 'data' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3557">
                  <DatabaseIcon size={16} className="inline-block mr-2" data-id="element-3558" />
                  Données
                </button>
              </nav>
            </div>
            {/* Tab content */}
            <div className="p-6" data-id="element-3559">
              {/* General settings tab */}
              {activeTab === 'general' && <div className="space-y-6" data-id="element-3560">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3561">
                    Paramètres généraux
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3562">
                    <div data-id="element-3563">
                      <label htmlFor="language" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3564">
                        Langue
                      </label>
                      <select id="language" name="language" value={settings.language} onChange={e => handleSimpleSettingChange('language', e.target.value)} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3565">
                        <option value="Français" data-id="element-3566">Français</option>
                        <option value="English" data-id="element-3567">English</option>
                        <option value="العربية" data-id="element-3568">العربية</option>
                      </select>
                    </div>
                    <div data-id="element-3569">
                      <label htmlFor="timeZone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3570">
                        Fuseau horaire
                      </label>
                      <select id="timeZone" name="timeZone" value={settings.timeZone} onChange={e => handleSimpleSettingChange('timeZone', e.target.value)} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3571">
                        <option value="Europe/Paris" data-id="element-3572">
                          Europe/Paris (UTC+1)
                        </option>
                        <option value="Africa/Tunis" data-id="element-3573">
                          Africa/Tunis (UTC+1)
                        </option>
                        <option value="Africa/Algiers" data-id="element-3574">
                          Africa/Algiers (UTC+1)
                        </option>
                        <option value="Africa/Casablanca" data-id="element-3575">
                          Africa/Casablanca (UTC+1)
                        </option>
                        <option value="Africa/Dakar" data-id="element-3576">
                          Africa/Dakar (UTC+0)
                        </option>
                      </select>
                    </div>
                    <div data-id="element-3577">
                      <label htmlFor="dateFormat" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3578">
                        Format de date
                      </label>
                      <select id="dateFormat" name="dateFormat" value={settings.dateFormat} onChange={e => handleSimpleSettingChange('dateFormat', e.target.value)} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3579">
                        <option value="DD/MM/YYYY" data-id="element-3580">DD/MM/YYYY</option>
                        <option value="MM/DD/YYYY" data-id="element-3581">MM/DD/YYYY</option>
                        <option value="YYYY-MM-DD" data-id="element-3582">YYYY-MM-DD</option>
                      </select>
                    </div>
                    <div data-id="element-3583">
                      <label htmlFor="currency" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3584">
                        Devise
                      </label>
                      <select id="currency" name="currency" value={settings.currency} onChange={e => handleSimpleSettingChange('currency', e.target.value)} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3585">
                        <option value="EUR" data-id="element-3586">Euro (€)</option>
                        <option value="TND" data-id="element-3587">Dinar Tunisien (TND)</option>
                        <option value="MAD" data-id="element-3588">Dirham Marocain (MAD)</option>
                        <option value="DZD" data-id="element-3589">Dinar Algérien (DZD)</option>
                        <option value="XOF" data-id="element-3590">Franc CFA (XOF)</option>
                        <option value="USD" data-id="element-3591">Dollar Américain ($)</option>
                      </select>
                    </div>
                    <div className="md:col-span-2" data-id="element-3592">
                      <label htmlFor="exportFormat" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3593">
                        Format d'export par défaut
                      </label>
                      <div className="flex space-x-4 mt-2" data-id="element-3594">
                        <label className="inline-flex items-center" data-id="element-3595">
                          <input type="radio" className="form-radio h-4 w-4 text-blue-600" name="exportFormat" value="PDF" checked={settings.exportFormat === 'PDF'} onChange={e => handleSimpleSettingChange('exportFormat', e.target.value)} data-id="element-3596" />
                          <span className="ml-2 text-gray-700" data-id="element-3597">PDF</span>
                        </label>
                        <label className="inline-flex items-center" data-id="element-3598">
                          <input type="radio" className="form-radio h-4 w-4 text-blue-600" name="exportFormat" value="EXCEL" checked={settings.exportFormat === 'EXCEL'} onChange={e => handleSimpleSettingChange('exportFormat', e.target.value)} data-id="element-3599" />
                          <span className="ml-2 text-gray-700" data-id="element-3600">Excel</span>
                        </label>
                        <label className="inline-flex items-center" data-id="element-3601">
                          <input type="radio" className="form-radio h-4 w-4 text-blue-600" name="exportFormat" value="CSV" checked={settings.exportFormat === 'CSV'} onChange={e => handleSimpleSettingChange('exportFormat', e.target.value)} data-id="element-3602" />
                          <span className="ml-2 text-gray-700" data-id="element-3603">CSV</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="pt-4" data-id="element-3604">
                    <Button variant="primary" onClick={handleSave} className="flex items-center shadow-md shadow-yellow-500/20" data-id="element-3605">
                      <SaveIcon size={16} className="mr-2" data-id="element-3606" />
                      Enregistrer les paramètres
                    </Button>
                  </div>
                </div>}
              {/* Notifications tab */}
              {activeTab === 'notifications' && <div className="space-y-6" data-id="element-3607">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3608">
                    Paramètres de notifications
                  </h3>
                  <div data-id="element-3609">
                    <h4 className="text-base font-medium text-gray-900 mb-3" data-id="element-3610">
                      Notifications par email
                    </h4>
                    <div className="space-y-3" data-id="element-3611">
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3612">
                        <div data-id="element-3613">
                          <span className="text-gray-900" data-id="element-3614">
                            Nouveaux appels d'offres correspondants
                          </span>
                          <p className="text-sm text-gray-500" data-id="element-3615">
                            Recevez un email lorsqu'un nouvel appel d'offres
                            correspond à vos critères
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3616">
                          <input type="checkbox" name="newTenders" id="newTenders" checked={settings.emailNotifications.newTenders} onChange={e => handleSettingChange('emailNotifications', 'newTenders', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3617" />
                          <label htmlFor="newTenders" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.emailNotifications.newTenders ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3618">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.emailNotifications.newTenders ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3619"></span>
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3620">
                        <div data-id="element-3621">
                          <span className="text-gray-900" data-id="element-3622">
                            Mises à jour des appels d'offres
                          </span>
                          <p className="text-sm text-gray-500" data-id="element-3623">
                            Recevez un email lorsqu'un appel d'offres que vous
                            suivez est mis à jour
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3624">
                          <input type="checkbox" name="tenderUpdates" id="tenderUpdates" checked={settings.emailNotifications.tenderUpdates} onChange={e => handleSettingChange('emailNotifications', 'tenderUpdates', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3625" />
                          <label htmlFor="tenderUpdates" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.emailNotifications.tenderUpdates ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3626">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.emailNotifications.tenderUpdates ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3627"></span>
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3628">
                        <div data-id="element-3629">
                          <span className="text-gray-900" data-id="element-3630">
                            Récapitulatif hebdomadaire
                          </span>
                          <p className="text-sm text-gray-500" data-id="element-3631">
                            Recevez un récapitulatif hebdomadaire des appels
                            d'offres pertinents
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3632">
                          <input type="checkbox" name="weeklyDigest" id="weeklyDigest" checked={settings.emailNotifications.weeklyDigest} onChange={e => handleSettingChange('emailNotifications', 'weeklyDigest', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3633" />
                          <label htmlFor="weeklyDigest" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.emailNotifications.weeklyDigest ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3634">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.emailNotifications.weeklyDigest ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3635"></span>
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3636">
                        <div data-id="element-3637">
                          <span className="text-gray-900" data-id="element-3638">
                            Emails marketing
                          </span>
                          <p className="text-sm text-gray-500" data-id="element-3639">
                            Recevez des emails concernant les nouvelles
                            fonctionnalités et offres
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3640">
                          <input type="checkbox" name="marketingEmails" id="marketingEmails" checked={settings.emailNotifications.marketingEmails} onChange={e => handleSettingChange('emailNotifications', 'marketingEmails', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3641" />
                          <label htmlFor="marketingEmails" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.emailNotifications.marketingEmails ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3642">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.emailNotifications.marketingEmails ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3643"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-8" data-id="element-3644">
                    <h4 className="text-base font-medium text-gray-900 mb-3" data-id="element-3645">
                      Notifications dans l'application
                    </h4>
                    <div className="space-y-3" data-id="element-3646">
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3647">
                        <div data-id="element-3648">
                          <span className="text-gray-900" data-id="element-3649">
                            Nouveaux appels d'offres
                          </span>
                          <p className="text-sm text-gray-500" data-id="element-3650">
                            Recevez une notification dans l'application pour les
                            nouveaux appels d'offres
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3651">
                          <input type="checkbox" name="appNewTenders" id="appNewTenders" checked={settings.appNotifications.newTenders} onChange={e => handleSettingChange('appNotifications', 'newTenders', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3652" />
                          <label htmlFor="appNewTenders" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.appNotifications.newTenders ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3653">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.appNotifications.newTenders ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3654"></span>
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3655">
                        <div data-id="element-3656">
                          <span className="text-gray-900" data-id="element-3657">
                            Mises à jour des appels d'offres
                          </span>
                          <p className="text-sm text-gray-500" data-id="element-3658">
                            Recevez une notification lorsqu'un appel d'offres
                            est mis à jour
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3659">
                          <input type="checkbox" name="appTenderUpdates" id="appTenderUpdates" checked={settings.appNotifications.tenderUpdates} onChange={e => handleSettingChange('appNotifications', 'tenderUpdates', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3660" />
                          <label htmlFor="appTenderUpdates" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.appNotifications.tenderUpdates ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3661">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.appNotifications.tenderUpdates ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3662"></span>
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center justify-between py-2 border-b border-gray-100" data-id="element-3663">
                        <div data-id="element-3664">
                          <span className="text-gray-900" data-id="element-3665">Alertes système</span>
                          <p className="text-sm text-gray-500" data-id="element-3666">
                            Recevez des notifications concernant votre compte et
                            abonnement
                          </p>
                        </div>
                        <div className="relative inline-block w-10 align-middle select-none" data-id="element-3667">
                          <input type="checkbox" name="systemAlerts" id="systemAlerts" checked={settings.appNotifications.systemAlerts} onChange={e => handleSettingChange('appNotifications', 'systemAlerts', e.target.checked)} className="opacity-0 absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" data-id="element-3668" />
                          <label htmlFor="systemAlerts" className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${settings.appNotifications.systemAlerts ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-3669">
                            <span className={`block h-6 w-6 rounded-full bg-white transform transition-transform duration-200 ease-in-out ${settings.appNotifications.systemAlerts ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-3670"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pt-4" data-id="element-3671">
                    <Button variant="primary" onClick={handleSave} className="flex items-center shadow-md shadow-yellow-500/20" data-id="element-3672">
                      <SaveIcon size={16} className="mr-2" data-id="element-3673" />
                      Enregistrer les préférences
                    </Button>
                  </div>
                </div>}
              {/* Security tab */}
              {activeTab === 'security' && <div className="space-y-6" data-id="element-3674">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3675">
                    Paramètres de sécurité
                  </h3>
                  <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mb-6" data-id="element-3676">
                    <div className="flex items-start" data-id="element-3677">
                      <ShieldIcon size={20} className="text-blue-600 mr-3 mt-0.5" data-id="element-3678" />
                      <div data-id="element-3679">
                        <h4 className="font-medium text-blue-900" data-id="element-3680">
                          Sécurité du compte
                        </h4>
                        <p className="mt-1 text-sm text-blue-700" data-id="element-3681">
                          Pour renforcer la sécurité de votre compte, nous vous
                          recommandons d'activer l'authentification à deux
                          facteurs et de changer régulièrement votre mot de
                          passe.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-3682">
                    <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-3683">
                      Authentification à deux facteurs
                    </h4>
                    <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-200" data-id="element-3684">
                      <div data-id="element-3685">
                        <p className="text-gray-900" data-id="element-3686">
                          Authentification par SMS
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-3687">
                          Recevez un code de vérification par SMS à chaque
                          connexion
                        </p>
                      </div>
                      <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50" data-id="element-3688">
                        Activer
                      </Button>
                    </div>
                    <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-200" data-id="element-3689">
                      <div data-id="element-3690">
                        <p className="text-gray-900" data-id="element-3691">
                          Authentification par email
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-3692">
                          Recevez un code de vérification par email à chaque
                          connexion
                        </p>
                      </div>
                      <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50" data-id="element-3693">
                        Activer
                      </Button>
                    </div>
                    <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-200" data-id="element-3694">
                      <div data-id="element-3695">
                        <p className="text-gray-900" data-id="element-3696">
                          Application d'authentification
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-3697">
                          Utilisez une application comme Google Authenticator ou
                          Microsoft Authenticator
                        </p>
                      </div>
                      <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50" data-id="element-3698">
                        Configurer
                      </Button>
                    </div>
                  </div>
                  <div data-id="element-3699">
                    <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-3700">
                      Sessions actives
                    </h4>
                    <div className="space-y-3" data-id="element-3701">
                      <div className="bg-white p-3 border border-gray-200 rounded-md" data-id="element-3702">
                        <div className="flex items-center justify-between" data-id="element-3703">
                          <div data-id="element-3704">
                            <div className="font-medium" data-id="element-3705">
                              Chrome sur Windows
                            </div>
                            <div className="text-sm text-gray-500" data-id="element-3706">
                              Tunis, Tunisie · Actif maintenant
                            </div>
                          </div>
                          <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full" data-id="element-3707">
                            Session actuelle
                          </div>
                        </div>
                      </div>
                      <div className="bg-white p-3 border border-gray-200 rounded-md" data-id="element-3708">
                        <div className="flex items-center justify-between" data-id="element-3709">
                          <div data-id="element-3710">
                            <div className="font-medium" data-id="element-3711">Safari sur iPhone</div>
                            <div className="text-sm text-gray-500" data-id="element-3712">
                              Tunis, Tunisie · Dernière activité il y a 2 jours
                            </div>
                          </div>
                          <Button variant="outline" size="sm" className="text-xs" data-id="element-3713">
                            Déconnecter
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4" data-id="element-3714">
                      <Button variant="outline" className="text-red-600 border-red-600 hover:bg-red-50" data-id="element-3715">
                        Déconnecter toutes les autres sessions
                      </Button>
                    </div>
                  </div>
                  <div data-id="element-3716">
                    <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-3717">
                      Changer votre mot de passe
                    </h4>
                    <div className="space-y-4" data-id="element-3718">
                      <div data-id="element-3719">
                        <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3720">
                          Mot de passe actuel
                        </label>
                        <input type="password" id="currentPassword" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" placeholder="••••••••" data-id="element-3721" />
                      </div>
                      <div data-id="element-3722">
                        <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3723">
                          Nouveau mot de passe
                        </label>
                        <input type="password" id="newPassword" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" placeholder="••••••••" data-id="element-3724" />
                        <p className="mt-1 text-xs text-gray-500" data-id="element-3725">
                          Le mot de passe doit contenir au moins 8 caractères,
                          dont une lettre majuscule, une lettre minuscule et un
                          chiffre.
                        </p>
                      </div>
                      <div data-id="element-3726">
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3727">
                          Confirmer le nouveau mot de passe
                        </label>
                        <input type="password" id="confirmPassword" className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" placeholder="••••••••" data-id="element-3728" />
                      </div>
                      <div data-id="element-3729">
                        <Button variant="primary" className="shadow-md shadow-yellow-500/20 mt-2" data-id="element-3730">
                          <KeyIcon size={16} className="mr-2" data-id="element-3731" />
                          Mettre à jour le mot de passe
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Data tab */}
              {activeTab === 'data' && <div className="space-y-6" data-id="element-3732">
                  <h3 className="text-lg font-medium text-gray-900" data-id="element-3733">
                    Paramètres de données
                  </h3>
                  <div data-id="element-3734">
                    <h4 className="text-base font-medium text-gray-900 mb-3" data-id="element-3735">
                      Rétention des données
                    </h4>
                    <p className="text-sm text-gray-500 mb-4" data-id="element-3736">
                      Définissez la durée pendant laquelle vos données sont
                      conservées dans le système
                    </p>
                    <div className="space-y-4" data-id="element-3737">
                      <div data-id="element-3738">
                        <label htmlFor="searchHistory" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3739">
                          Historique de recherche (jours)
                        </label>
                        <select id="searchHistory" name="searchHistory" value={settings.dataRetention.searchHistory} onChange={e => handleSettingChange('dataRetention', 'searchHistory', parseInt(e.target.value))} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3740">
                          <option value="7" data-id="element-3741">7 jours</option>
                          <option value="30" data-id="element-3742">30 jours</option>
                          <option value="90" data-id="element-3743">90 jours</option>
                          <option value="180" data-id="element-3744">180 jours</option>
                          <option value="365" data-id="element-3745">365 jours</option>
                        </select>
                      </div>
                      <div data-id="element-3746">
                        <label htmlFor="downloadedDocuments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3747">
                          Documents téléchargés (jours)
                        </label>
                        <select id="downloadedDocuments" name="downloadedDocuments" value={settings.dataRetention.downloadedDocuments} onChange={e => handleSettingChange('dataRetention', 'downloadedDocuments', parseInt(e.target.value))} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-blue-500 focus:border-blue-500" data-id="element-3748">
                          <option value="30" data-id="element-3749">30 jours</option>
                          <option value="90" data-id="element-3750">90 jours</option>
                          <option value="180" data-id="element-3751">180 jours</option>
                          <option value="365" data-id="element-3752">365 jours</option>
                          <option value="730" data-id="element-3753">2 ans</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="pt-4 border-t border-gray-200" data-id="element-3754">
                    <h4 className="text-base font-medium text-gray-900 mb-4" data-id="element-3755">
                      Exportation et suppression des données
                    </h4>
                    <div className="space-y-4" data-id="element-3756">
                      <div data-id="element-3757">
                        <Button variant="outline" className="flex items-center" data-id="element-3758">
                          <DatabaseIcon size={16} className="mr-2" data-id="element-3759" />
                          Exporter mes données
                        </Button>
                        <p className="mt-1 text-xs text-gray-500" data-id="element-3760">
                          Téléchargez toutes vos données personnelles dans un
                          format standard
                        </p>
                      </div>
                      <div data-id="element-3761">
                        <Button variant="outline" className="text-red-600 border-red-600 hover:bg-red-50 flex items-center" data-id="element-3762">
                          <XIcon size={16} className="mr-2" data-id="element-3763" />
                          Supprimer mon compte
                        </Button>
                        <p className="mt-1 text-xs text-gray-500" data-id="element-3764">
                          Supprimez définitivement votre compte et toutes les
                          données associées
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="pt-4" data-id="element-3765">
                    <Button variant="primary" onClick={handleSave} className="flex items-center shadow-md shadow-yellow-500/20" data-id="element-3766">
                      <SaveIcon size={16} className="mr-2" data-id="element-3767" />
                      Enregistrer les paramètres
                    </Button>
                  </div>
                </div>}
            </div>
          </div>
        </main>
      </div>
    </div>;
}